import CustomStore from "devextreme/data/custom_store";
import { apiConfiguration } from "../apiConfig";
import { OrdiniApi, GetOrdiniDettagliRequest } from "../data/apis/OrdiniApi";

export function ordersDetailDataSource(idOrdine: number) {

    return new CustomStore({
        key: "idDettaglio",
        loadMode: 'raw',
        load: (loadOptions) => {
            const api = new OrdiniApi(apiConfiguration);

            const request: GetOrdiniDettagliRequest = {
                idOrdine: idOrdine
            };

            return api.getOrdiniDettagli(request);
        },

        insert: (values) => {
            const api = new OrdiniApi(apiConfiguration);

            return api.insertOrdineDettaglio({
                idOrdine: idOrdine, 
                ordineDettaglioCreateDTO: values
            });
        },

        update: (key, values) => {
            const api = new OrdiniApi(apiConfiguration);
            return api.updateOrdineDettaglio({
                idDettaglio: key,
                idOrdine: idOrdine,
                ordineDettaglioUpdateDTO: values
            });
        },

        remove: (key) => {
            const api = new OrdiniApi(apiConfiguration);
            return api.deleteOrdineDettaglio({
                idDettaglio: key,
                idOrdine: idOrdine
            });
        }
       
    });
}
